"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toPairs = void 0;
exports.toPairs = (obj) => {
    const entries = [];
    Object.keys(obj).forEach(k => entries.push([k, obj[k]]));
    return entries;
};
//# sourceMappingURL=toPairs.js.map